var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.701,
    height: 9.142,
    viewBox: "4187.966 5465.929 11.701 9.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4187.966 5468.489v-.366c0-.303.246-.548.549-.548h8.226v-1.097c0-.488.592-.732.937-.388l1.828 1.828a.548.548 0 0 1 0 .776l-1.828 1.828a.549.549 0 0 1-.937-.388v-1.097h-8.226a.548.548 0 0 1-.549-.548Zm11.152 3.473h-8.227v-1.096a.549.549 0 0 0-.936-.388l-1.828 1.828a.548.548 0 0 0 0 .776l1.828 1.828a.549.549 0 0 0 .936-.388v-1.097h8.227a.548.548 0 0 0 .549-.548v-.366a.548.548 0 0 0-.549-.549Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-exchange-alt"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleChangeIcon);
export default __webpack_public_path__ + "static/media/RoleChangeIcon.466a987f4912560a37191be413e6d51b.svg";
export { ForwardRef as ReactComponent };